import i18n from '../../language/index'
import img_effects from '@/base/img_effects'
import { create_title } from '@/base/titleData';
let font = {
  radio_val: 'default',
  default: {
    fsItalics: 'normal',
    fontUnderline: 'none',
    fsWeight: 'normal',
    fontSize: 14,
    fontColor:'rgba(51,51,51,1)',
    fontFamily: 'Arial',
    textAlign:'left',
    pattern: 'pure_color',
    linear_gradient: {
      start_color: "rgba(156,40,177,1)",
      end_color: "rgba(0, 0, 0,1)",
      start_pointer: 12,
      end_pointer: 100,
      deg: 0
    },
  },
  custom: {
    fsItalics: 'normal',
    fontUnderline: 'none',
    fontSize: 14,
    fsWeight: 'normal',
    fontColor: 'rgba(51,51,51,1)',
    fontFamily: 'Arial',
    textAlign:'left',
    pattern: 'pure_color',
    linear_gradient: {
      start_color: "rgba(156,40,177,1)",
      end_color: "rgba(0, 0, 0,1)",
      start_pointer: 12,
      end_pointer: 100,
      deg: 0
    },
  }
}
export default {
  ...img_effects,
  pc_widgets_infor: {
    // height:40,//特殊字段，只存在搜索和按钮
    img: 'https://staticjs.71360.com/static/txys-001/image/illustration/login_pc_bg.png', // 设置两栏的图片
    title: {
      text: {
        ...create_title(i18n.t('view_login_index_34')).text,
        isHidden: false
      },
      font: {
        radio_val: 'default',
        default: {
          ...create_title(i18n.t('view_login_index_34')).font.default,
          fontSize: 36,
          fontColor_globalColor:'rgba(48, 120, 208, 1)', // 标题栏这边所有的 默认值 都是 主题色 
          textAlign:'center',
        },
        custom: {
          ...create_title(i18n.t('view_login_index_34')).font.custom,
          fontSize: 36,
          fontColor_globalColor: 'rgba(48, 120, 208, 1)',
          textAlign:'center',
        }
      },
      height: {
        ...create_title(i18n.t('view_login_index_34')).height
      },
      background: {
        ...create_title(i18n.t('view_login_index_34')).background
      }
    },
    //背景
    login_name: { // #3078D0
      radio_val: 'default',
      default: {
        ...font.default,
        fontSize: 38,
        fontColor:'rgba(48, 120, 208, 1)',
        textAlign:'center',
      },
      custom: {
        ...font.custom,
        fontSize: 38,
        fontColor: 'rgba(48, 120, 208, 1)',
        textAlign:'center',
      }
    },
    login_input:{
      radio_val: 'default',
      default:{
        type:'color', // 背景设置-类型
        color: 'rgba(247, 248, 251, 1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      },
      custom:{
        type:'color', // 背景设置-类型
        // img:'', // 背景设置-图片的URL
        color: 'rgba(247, 248, 251, 1)', // 背景设置-颜色
        pattern: 'pure_color',
        linear_gradient: {
          start_color: "rgba(156,40,177,1)",
          end_color: "rgba(0, 0, 0,1)",
          start_pointer: 12,
          end_pointer: 100,
          deg: 90
        },
      }
    },
    //登录项名称
    login_item_title: {
      ...font
    },
    //登录项内容
    login_item_content: {
      radio_val: 'default',
      default: {
        ...font.default,
        fontColor: 'rgba(102, 102, 102, 1)',
        fontSize: 18,
      },
      custom: {
        ...font.custom,
        fontColor: 'rgba(102, 102, 102, 1)',
        fontSize: 18
      }
      
    },
    borderColor:{
      radio_val: 'default',
        default: {
          color:"rgba(176, 176, 176, 1)"
        },
        custom: {
          color:"rgba(176, 176, 176, 1)"
        }
    },
    // 按钮设置 
    button_set: {
      background: {
        radio_val: 'default',
        default:{
          type: 'color', // 背景设置-类型
          // 默认值始终是主题颜色
          bgColor_globalColor:'rgba(48, 120, 208, 1)',
          color: 'rgba(48, 120, 208, 1)', // 背景设置-颜色 
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
        custom:{
          type:'color', // 背景设置-类型
          // img:'', // 背景设置-图片的URL
          bgColor_globalColor:'rgba(48, 120, 208, 1)',
          color: 'rgba(48, 120, 208, 1)', // 背景设置-颜色
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        }
      },
      background_register: {
        radio_val: 'default',
        default:{
          type:'color', // 背景设置-类型
          color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色 
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        },
        custom:{
          type:'color', // 背景设置-类型
          // img:'', // 背景设置-图片的URL
          color: 'rgba(255, 255, 255, 1)', // 背景设置-颜色 
          pattern: 'pure_color',
          linear_gradient: {
            start_color: "rgba(156,40,177,1)",
            end_color: "rgba(0, 0, 0,1)",
            start_pointer: 12,
            end_pointer: 100,
            deg: 90
          },
        }
      },
      font: {
        radio_val: 'default',
        default: {
          ...font.default,
          fontColor: 'rgba(255,255,255, 1)',
          fontSize: 18,
          textAlign: 'center',
          registerColor:'rgba(51,51,51,1)'
        },
        custom: {
          ...font.custom,
          fontColor: 'rgba(255,255,255, 1)',
          fontSize: 18,
          textAlign: 'center',
          registerColor:'rgba(51,51,51,1)'
        }
      },
      borderRadius:{ // 圆角
        radio_val: 'default',
        default: {
          value: 4,
        },
        custom: {
          value: 4,
        }
      },
      borderColor: {
        radio_val: 'default',
        default: {
          color:"rgba(48, 120, 208, 1)"
        },
        custom: {
          color:"rgba(48, 120, 208, 1)"
        }
      }
    }
  },
  mb_widgets_infor: {
    img: 'https://staticjs.71360.com/static/txys-001/image/illustration/login_mb_bg.png',
    title: { 
      text: {
        ...create_title(i18n.t('view_login_index_34')).text,
        isHidden: false
      },
      font: {
        radio_val: 'default',
        default: {
          ...create_title(i18n.t('view_login_index_34')).font.default,
          fontSize: 18,
          fontColor_globalColor:'rgba(69, 69, 69, 1)',
          textAlign: 'left',
          fsWeight: 'bold',
        },
        custom: {
          ...create_title(i18n.t('view_login_index_34')).font.custom,
          fontSize: 18,
          fontColor_globalColor:'rgba(69, 69, 69, 1)',
          textAlign: 'left',
          fsWeight: 'bold'
        }
      },
      height: {
        ...create_title(i18n.t('view_login_index_34')).height
      },
      background: {
        ...create_title(i18n.t('view_login_index_34')).background
      }
    },
  },
  listArr: {
    module_style:'0',// 模式设置
    content: i18n.t('widgets_basic_floating_frame_style_542'),
    title: i18n.t('view_login_index_34'),
    login_type: "username",
    login_list:[{
      id: 'email',
      value: i18n.t('widgets_basic_login_style_2571'),
      isShow: true
    }, {
      id: 'phone',
      value: i18n.t('widgets_basic_login_style_2572'),
      isShow: true,
    }, {
      id: 'username',
      value: i18n.t('view_login_index_31'),
      isShow: true
    }]
  },
  pc_infor: {
    marginTop: '0%',
    marginLeft: '0%',
    marginRight: '0%',
    marginBottom: '0%',
    textAlign: 'center'
  },
  mb_infor: {
    marginTop: '2.666%',
    marginRight: '0%',
    marginBottom: '1.333%',
    marginLeft: '0%',
    textAlign: 'center'
  },
}


// WEBPACK FOOTER //
// ./src/widgets/basic_login/style.js